import { render, staticRenderFns } from "./ProviderThanks.vue?vue&type=template&id=a3c2212a&scoped=true"
import script from "./ProviderThanks.vue?vue&type=script&lang=js"
export * from "./ProviderThanks.vue?vue&type=script&lang=js"
import style0 from "./ProviderThanks.vue?vue&type=style&index=0&id=a3c2212a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c2212a",
  null
  
)

export default component.exports